import { lazy } from 'react';

const Spin = lazy(() => import('./Spin'));

export { Spin };
